import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit,canModify}) => {
    const rows = [
        { label: 'Tax Type', value: data.taxType },
        { label: 'Tax Percentage', value: data.taxPercentage },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.taxProfileName}
            rows={rows}
            menuItems={canModify ? menuItems : undefined}
        />
    );
};

export default Mobile;
